
export const exportLicenseToXMLFormat = (licenseContent: any) => {
    const convertedBase64Data = arrayBufferToBase64(licenseContent.fileContentBytes);
    var exportedLicenseXMLDocument = document.createElement("a");
    exportedLicenseXMLDocument.href = `data:${licenseContent.fileType};base64,` + convertedBase64Data;
    exportedLicenseXMLDocument.download = `${licenseContent.fileName}`;
    exportedLicenseXMLDocument.click();
} 

function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

export async function getArrayBufferFromBlob(blob){
    const base64DataFromBlob = await blobToBase64(blob);
    return base64ToArrayBuffer(base64DataFromBlob);
}

function base64ToArrayBuffer(base64) {
    const base64SplitData = base64.split(',');
    const base64Data = base64SplitData[1];
    var binary_string = window.atob(base64Data);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
}

function blobToBase64(blob) {

    // Prevent exceptions from crashing the app if we close the dialog without selecting a file to import
    if (!blob) {
        return Promise.resolve(null);
    }

    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}